import React from 'react';
import { NavLink } from 'react-router-dom';

const Header = () => {
  return (
  <header>
    <h1>Homeless Resources</h1>

    <nav id="nav-main">             
      <ul>
        <li><NavLink exact to="/">Home</NavLink></li>
        <li><NavLink to="/statistics">Statistics</NavLink></li>
        <li><NavLink to="/help">Help</NavLink></li>
        <li>
          <a href="#nothing.html" title="How to help Homeless Needs">Services</a>

          <ul>
            <li><NavLink to="/clothing">Clothing</NavLink></li>
            <li><NavLink to="/meals">Meals</NavLink></li>
            <li><NavLink to="/shelter">Shelter</NavLink></li>
          </ul>

        </li>
        <li><NavLink to="/contact" title="Contact us">Contact</NavLink></li>
      </ul>
    </nav>
  </header>
  );
}

export default Header;